
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/golf/programs",
      function () {
        return require("private-next-pages/golf/programs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/golf/programs"])
      });
    }
  